import { SidebarProvider } from '../../components/ui/sidebar'
import { AppSidebar } from '../../components/layout/sidebar'
import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { cn } from '../../lib/utils'
import { useAuthStore } from '../../stores/auth'
import { UserRole } from '../../constants/user'

const RootAuthenticated: React.FC = () => {
  const location = useLocation()
  const user = useAuthStore((state) => state.user)
  
  // Redirect Manager to /s3-file if they try to access root or other admin-only routes
  if (user?.role === UserRole.MANAGER && location.pathname === '/') {
    return <Navigate to="/s3-file" replace />
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <div
        id='content'
        className={cn(
          'ml-auto w-full max-w-full',
          'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
          'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
          'transition-[width] duration-200 ease-linear',
          'flex h-svh flex-col',
          'group-data-[scroll-locked=1]/body:h-full',
          'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh',
        )}
      >
        <Outlet />
      </div>
    </SidebarProvider>
  )
}

export default RootAuthenticated
